import type { FeatureManifest } from '@/platform/navigation/featureManifest'

export const standardsManifest: FeatureManifest = {
  id: 'english-language-standards',
  path: 'english-knowledge/standards/*',
  navPath: '/english-knowledge/standards',
  label: 'Tiêu chuẩn',
  description: 'Theo dõi chuẩn năng lực tiếng Anh',
  navigationGroup: { id: 'english-skills', label: 'Tiêu chuẩn' },
  load: () => import('./entry'),
}

